import { render, staticRenderFns } from "./FormulaLinhaBuilder.vue?vue&type=template&id=37fd5e42&scoped=true"
import script from "./FormulaLinhaBuilder.vue?vue&type=script&lang=js"
export * from "./FormulaLinhaBuilder.vue?vue&type=script&lang=js"
import style0 from "./FormulaLinhaBuilder.vue?vue&type=style&index=0&id=37fd5e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fd5e42",
  null
  
)

export default component.exports